import {client} from "@/data/axios";
import {ResponseError} from "@/types";
import {resolveError} from "@/data/_resolveError";
import {FaceGroupingJob, FacePerson, FacePersonPhoto} from "@/types/FaceGroupingType";

export const startFaceGrouping = (
    gallery: string,
    success = (job: FaceGroupingJob) => {},
    failed = (type: ResponseError, data: any) => {}
) => {
    client.post(`/galleries/${gallery}/face-grouping/start`)
        .then(({data}: any) => {
            success(data.data);
        }).catch((error) => resolveError(error, failed));
};

export const getFaceGroupingStatus = (
    gallery: string,
    success = (job: FaceGroupingJob | {status: 'none'}) => {},
    failed = (type: ResponseError, data: any) => {}
) => {
    client.get(`/galleries/${gallery}/face-grouping/status`)
        .then(({data}: any) => {
            success(data.data);
        }).catch((error) => resolveError(error, failed));
};

export const getPeople = (
    gallery: string,
    success = (people: FacePerson[]) => {},
    failed = (type: ResponseError, data: any) => {}
) => {
    client.get(`/galleries/${gallery}/face-grouping/people`)
        .then(({data}: any) => {
            success(data.data.people);
        }).catch((error) => resolveError(error, failed));
};

export const getPersonPhotos = (
    gallery: string,
    cluster: number | string,
    success = (photos: FacePersonPhoto[]) => {},
    failed = (type: ResponseError, data: any) => {}
) => {
    client.get(`/galleries/${gallery}/face-grouping/people/${cluster}`)
        .then(({data}: any) => {
            success(data.data.photos);
        }).catch((error) => resolveError(error, failed));
};

export const deleteFaceGrouping = (
    gallery: string,
    success = () => {},
    failed = (type: ResponseError, data: any) => {}
) => {
    client.delete(`/galleries/${gallery}/face-grouping`)
        .then(() => {
            success();
        }).catch((error) => resolveError(error, failed));
};
